import { LucideIcon } from "lucide-react";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface FAQItemProps {
  emoji: LucideIcon | React.ReactNode;
  question: string;
  answer: string;
  value: string;
}

export const FAQItem = ({ emoji, question, answer, value }: FAQItemProps) => {
  const IconComponent = emoji as LucideIcon;
  
  return (
    <AccordionItem value={value} className="border rounded-lg bg-white shadow-sm hover:shadow-md transition-shadow duration-200">
      <AccordionTrigger className="hover:no-underline px-6 py-4">
        <div className="flex items-center gap-4">
          {typeof emoji === "function" ? <IconComponent className="w-6 h-6 text-primary" /> : emoji}
          <span className="text-lg font-medium text-left">{question}</span>
        </div>
      </AccordionTrigger>
      <AccordionContent className="text-gray-600 px-6 pb-4 pt-2">
        {answer}
      </AccordionContent>
    </AccordionItem>
  );
};